import React from 'react';
import { ResetPasswordContainer, ResetPasswordWrapper } from './styles';
import ResetPasswordForm from './components/ResetPasswordForm';

const ResetPassword = () => {
  return (
    <ResetPasswordContainer>
      <ResetPasswordWrapper>
        <ResetPasswordForm />
      </ResetPasswordWrapper>
    </ResetPasswordContainer>
  );
};
export default ResetPassword;
